module.exports = __webpack_public_path__ + "img/zghlwfyyjy.526b8018.png";